import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetReplenishmentSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetReplenishmentSettingsQuery = { __typename?: 'Query', replenishmentSettings?: { __typename?: 'ReplenishmentSettingsStateData', tenantId: string, forwardDaysLastYear: number, trailingDaysThisYear: number, defaultTargetWeeksOfSupply: number, inventoryTrailingDays: number, minUsableDaysThreshold?: number | null, roundToFullCart: boolean, sellThroughThreshold?: number | null, shipmentIncrement: number, allocationReservationPercentage: number, allocationType: Types.AllocationType, allocationPriorities: Array<Types.AllocationPriorityDimension>, updatedAt: Types.TDateISO, updatedBy: string, programWindowConfigs: Array<{ __typename?: 'ProgramWindowConfigStateData', program: string, minUsableDaysThreshold?: number | null, sellThroughThreshold?: number | null, trailingDaysThisYear?: number | null }> } | null };

export type ReplenishmentSettingsDetailsFragment = { __typename?: 'ReplenishmentSettingsStateData', tenantId: string, forwardDaysLastYear: number, trailingDaysThisYear: number, defaultTargetWeeksOfSupply: number, inventoryTrailingDays: number, minUsableDaysThreshold?: number | null, roundToFullCart: boolean, sellThroughThreshold?: number | null, shipmentIncrement: number, allocationReservationPercentage: number, allocationType: Types.AllocationType, allocationPriorities: Array<Types.AllocationPriorityDimension>, updatedAt: Types.TDateISO, updatedBy: string, programWindowConfigs: Array<{ __typename?: 'ProgramWindowConfigStateData', program: string, minUsableDaysThreshold?: number | null, sellThroughThreshold?: number | null, trailingDaysThisYear?: number | null }> };

export const ReplenishmentSettingsDetailsFragmentDoc = new TypedDocumentString(`
    fragment ReplenishmentSettingsDetails on ReplenishmentSettingsStateData {
  tenantId
  forwardDaysLastYear
  trailingDaysThisYear
  defaultTargetWeeksOfSupply
  inventoryTrailingDays
  minUsableDaysThreshold
  programWindowConfigs {
    program
    minUsableDaysThreshold
    sellThroughThreshold
    trailingDaysThisYear
  }
  roundToFullCart
  sellThroughThreshold
  shipmentIncrement
  allocationReservationPercentage
  allocationType
  allocationPriorities
  updatedAt
  updatedBy
}
    `, {"fragmentName":"ReplenishmentSettingsDetails"});
export const GetReplenishmentSettingsDocument = new TypedDocumentString(`
    query GetReplenishmentSettings {
  replenishmentSettings {
    ...ReplenishmentSettingsDetails
  }
}
    fragment ReplenishmentSettingsDetails on ReplenishmentSettingsStateData {
  tenantId
  forwardDaysLastYear
  trailingDaysThisYear
  defaultTargetWeeksOfSupply
  inventoryTrailingDays
  minUsableDaysThreshold
  programWindowConfigs {
    program
    minUsableDaysThreshold
    sellThroughThreshold
    trailingDaysThisYear
  }
  roundToFullCart
  sellThroughThreshold
  shipmentIncrement
  allocationReservationPercentage
  allocationType
  allocationPriorities
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetReplenishmentSettings: build.query<GetReplenishmentSettingsQuery, GetReplenishmentSettingsQueryVariables | void>({
      query: (variables) => ({ document: GetReplenishmentSettingsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetReplenishmentSettingsQuery, useLazyGetReplenishmentSettingsQuery } = injectedRtkApi;
